import { Observable, Subject } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { ApiUrlInjectionToken } from '@mitsubishi/shared/data-access';

import { UnitAccessoriesConfigurationBasePayload, UnitAccessoryResponse, UnitAccessoryUpdatePayload } from '../models';

@Injectable({
  providedIn: 'root',
})
export class UnitAccessoriesConfigurationService {
  private readonly baseUrl: string;

  #accessoryWithPerformanceImpactUpdated = new Subject<void>();

  constructor(
    private http: HttpClient,
    @Inject(ApiUrlInjectionToken) apiServerUrl: string
  ) {
    this.baseUrl = apiServerUrl + '/declaro';
  }

  readonly accessoryWithPerformanceImpactUpdated$ = this.#accessoryWithPerformanceImpactUpdated.asObservable();

  accessoryWithPerformanceImpactUpdated(): void {
    this.#accessoryWithPerformanceImpactUpdated.next();
  }

  getAccessories(
    sessionId: string,
    payload: UnitAccessoriesConfigurationBasePayload
  ): Observable<UnitAccessoryResponse> {
    return this.http.post<UnitAccessoryResponse>(`${this.baseUrl}/${sessionId}/records`, payload);
  }

  toggleAccessory(sessionId: string, req: UnitAccessoryUpdatePayload): Observable<UnitAccessoryResponse> {
    return this.http.post<UnitAccessoryResponse>(`${this.baseUrl}/${sessionId}/variable/edit`, req);
  }
}
